/**
 * CTASection - Call to Action section
 * Features: Full-width CTA, animated button
 */
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: "relative",
        background: (theme) => theme.gradients.secondary,
        color: "#ffffff",
        py: { xs: 8, md: 10 },
        textAlign: "center",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(ellipse at 30% 50%, rgba(255,255,255,0.08) 0%, transparent 60%)",
          zIndex: 0,
        },
      }}
    >
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 800,
              fontSize: { xs: "1.8rem", md: "2.4rem" },
              color: "#ffffff",
              letterSpacing: "-0.01em",
              mb: 2,
            }}
          >
            {t("home.cta.title")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "1rem", md: "1.1rem" },
              mb: 4,
              color: "rgba(255,255,255,0.85)",
              maxWidth: "560px",
              mx: "auto",
            }}
          >
            {t("home.cta.description")}
          </Typography>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{ display: "inline-block" }}
          >
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  color: "#fff",
                  borderColor: "rgba(255,255,255,0.75)",
                  borderWidth: 2,
                  px: 5,
                  py: 1.5,
                  fontSize: "1rem",
                  fontWeight: 700,
                  borderRadius: "8px",
                  "&:hover": {
                    borderColor: "#fff",
                    borderWidth: 2,
                    backgroundColor: "rgba(255,255,255,0.14)",
                  },
                }}
              >
                {t("home.cta.button")}
              </Button>
            </Link>
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CTASection;
